import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import './style/admin.css';
import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import AdminNav from "../../Components/AdminNav/AdminNav";

function AdminHome() {
    const location = useLocation();
    
    const user = location.state?.user;
    const [isCollapsed, setIsCollapsed] = useState(true);
  
    useEffect(() => {
      document.title = "Vinimark CMS";
    }, []);

    
  
    return (
      <div>
        <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user}/>
        <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user}/>
      </div>
    );
  }
  
  export default AdminHome;
